import { render, staticRenderFns } from "./RedeemGiftcardModal.vue?vue&type=template&id=3b60812c&"
import script from "./RedeemGiftcardModal.vue?vue&type=script&lang=js&"
export * from "./RedeemGiftcardModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports